import { EnvironmentType } from '../types/EnvironmentType';

export const FEATURE_FLAG_ENABLE_PAYMENT_DETAIL_STRIPE =
  process.env.REACT_APP_FEATURE_FLAG_ENABLE_PAYMENT_DETAIL_STRIPE ??
  localStorage.getItem('FEATURE_FLAG_ENABLE_PAYMENT_DETAIL_STRIPE');
export const FEATURE_FLAG_ENABLE_PAYMENT_DETAIL_TELECOM =
  process.env.REACT_APP_FEATURE_FLAG_ENABLE_PAYMENT_DETAIL_TELECOM ??
  localStorage.getItem('FEATURE_FLAG_ENABLE_PAYMENT_DETAIL_TELECOM');
export const GOOGLE_API_KEY =
  process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyCZRkjbw1BBzhSywtlg8SUzoiTwkA8acAQ';
// export const GOOGLE_TRANSLATE_URL =
//   process.env.REACT_APP_GOOGLE_TRANSLATE_URL ||
//   'https://translation.googleapis.com/language/translate/v2';

export const GOOGLE_TRANSLATE_URL =
  process.env.REACT_APP_GOOGLE_TRANSLATE_URL || 'https://stg.congrant.com/api/app/translation';
export const DEFAULT_LANG = process.env.REACT_APP_DEFAULT_LANG || 'ja';
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || 'localhost';

/**
 * Translation by Google
 */
export const FEATURE_FLAG_ENABLE_GOOGLE_TRANSLATE = localStorage.getItem(
  'FEATURE_FLAG_ENABLE_GOOGLE_TRANSLATE',
)
  ? localStorage.getItem('FEATURE_FLAG_ENABLE_GOOGLE_TRANSLATE') === 'true'
  : process.env.REACT_APP_FEATURE_FLAG_ENABLE_GOOGLE_TRANSLATE === 'true';
/**
 * Translation by Congrant backend
 */
export const FEATURE_FLAG_ENABLE_BACKEND_TRANSLATE = localStorage.getItem(
  'FEATURE_FLAG_ENABLE_BACKEND_TRANSLATE',
)
  ? localStorage.getItem('FEATURE_FLAG_ENABLE_BACKEND_TRANSLATE') === 'true'
  : process.env.REACT_APP_FEATURE_FLAG_ENABLE_BACKEND_TRANSLATE === 'true';

export const FEATURE_FLAG_ENABLE_ANNONYMOUS_SETTING = localStorage.getItem(
  'FEATURE_FLAG_ENABLE_ANNONYMOUS_SETTING',
)
  ? localStorage.getItem('FEATURE_FLAG_ENABLE_ANNONYMOUS_SETTING') === 'true'
  : process.env.REACT_APP_FEATURE_FLAG_ENABLE_ANNONYMOUS_SETTING === 'true';
export const FEATURE_FLAG_ENABLE_DETAIL_URL = localStorage.getItem('FEATURE_FLAG_ENABLE_DETAIL_URL')
  ? localStorage.getItem('FEATURE_FLAG_ENABLE_DETAIL_URL') === 'true'
  : process.env.REACT_APP_FEATURE_FLAG_ENABLE_DETAIL_URL === 'true';

export const ENABLED_TRANSLATE_LANGUAGES = [
  DEFAULT_LANG,
  ...(process.env.REACT_APP_ENABLED_TRANSLATE_LANGUAGES || 'en').split(','),
];

export const BIZ_WHITELIST_CO_IDS = (
  process.env.REACT_APP_BIZ_WHITELIST_CO_IDS || '360271,312265,379934'
).split(',');

export const ENABLED_PAYMENT_VER_2 = localStorage.getItem('ENABLED_PAYMENT_VER_2')
  ? localStorage.getItem('ENABLED_PAYMENT_VER_2') === 'true'
  : process.env.REACT_APP_ENABLED_PAYMENT_VER_2 === 'true';

export const ENABLED_SORT_IMAGES = localStorage.getItem('ENABLED_SORT_IMAGES')
  ? localStorage.getItem('ENABLED_SORT_IMAGES') === 'true'
  : process.env.REACT_APP_ENABLE_SORT_IMAGES === 'true';

export const ENV = process.env.REACT_APP_ENV || EnvironmentType.DEV;
